<template>
  <div>
    <SkeletonCard v-if="loading"></SkeletonCard>
    <div v-else>
  <LatestAnalysis v-if="!geoData" :data="data"></LatestAnalysis>
  <div class="headSectionIA">
    <span class="name">{{ $gettext("Visibility") }}</span>
    <div class="groupText">
      <div class="first">
        <translate>Indicates brand visibility in LLMs</translate>

      </div>
      <div class="second"><translate>Analysis based on %{numberOfPrompts} prompts.</translate></div>
    </div>
  </div>
      <div class="grid grid-cols-2 gap-4">
        <div class="box">
          <span class="title">{{ $gettext("Visibility (%)") }}</span>
          <p class="subTitle">{{ $gettext("Indicates the overall visibility percentage of the brand. Shows the visibility of the brand in each LLM. Confidence measures the level of reliability.") }}</p>

          <div class="tw-flex flex-col">
            <div class="">
              <div class="">
                <div class="text-center">

                  <ChartVisibility :value="globalPercent"></ChartVisibility>
                  <p class="text-24 font-semibold text-center mb-[28px]" :style="{color: getColorByPercent(globalPercent)}">
                    <span v-if="globalPercent < 50"><translate>Low</translate></span>
                    <span v-else-if="globalPercent < 80"><translate>Average</translate></span>
                    <span v-else-if="globalPercent < 100"><translate>High</translate></span>
                  </p>
                </div>

              </div>

            </div>
            <div class="">
              <div class="grid grid-cols-[minmax(0,2fr)_minmax(0,5fr)_minmax(0,1fr)_minmax(0,1fr)] headTableIA border-b border-[#F0EFF3] py-[12px] gap-[1%]">
                <div class="">LLMs</div>
                <div class="text-[#5E38D7] grid grid-cols-10 items-center relative px-[8px]" style="margin-right:20px;margin-left: 8px">
                  <span class="absolute left-[-70px]">nº prompts</span>
                  <span class="absolute" v-for="(range, index) in makeRangesContinuous" :key="`r${index}`"
                        :style="{ left: `${(index * 100) / (makeRangesContinuous.length - 1)}%` }">{{ range }}</span>

                </div>
                <div class=""></div>
                <div class=" text-right">{{ $gettext("Trust") }}</div>
              </div>

              <div v-for="(item, index) in metricsVisibility" :key="`m${index}`" class="grid grid-cols-[minmax(0,2fr)_minmax(0,5fr)_minmax(0,1fr)_minmax(0,1fr)] items-center border-b border-[#F0EFF3] py-[12px] gap-[1%]">
                <div class="text-12">
                  <img :src="getLogoByLLM(item.llm)" alt="" />
                </div>
                <div class="items-center text-11">
                  <ProgressBarVisibilityLLM :percent="item.metrics_results.visibility.total_ratio_pct" :ratio="item.metrics_results.visibility.total_ratio"></ProgressBarVisibilityLLM>
                </div>
                <div class="font-semibold text-14 text-right" :style="{color: getColorByPercent(item.metrics_results.visibility.total_ratio_pct)}">
                  {{ item.metrics_results.visibility.total_ratio_pct}} %
                </div>
                <div class="text-13 text-right">{{ item.metrics_results.visibility.confidence_score | formatNumber(2,2)}} </div>
              </div>

            </div>
          </div>
        </div>

        <div class="box">
          <span class="title"> <translate>Brand Ranking by Visibility in IAs</translate></span>
          <p class="subTitle"> <translate>Ranking of competing brands by visibility in indirect prompts</translate></p>
          <div style="height: 198px">
            <ChartCompetitors :chartData="dataChartCompetitors" style="height: 198px"></ChartCompetitors>
          </div>
          <div class="headTableIA border-b border-[#F0EFF3] py-[6px] rowBrand">
            <div class="tw-flex items-center gap-[1%] rowBrandBg">
              <div class="colBrandPosName">
                <div class="positionBrand">
                  <span>#</span>
                  <translate>Brands</translate>
                </div>

              </div>
              <div class="w-[17%] text-right">
                <translate>Visibility</translate>
              </div>
            </div>
          </div>

          <div v-for="(brand, index) in competitors" :key="`b${index}`"

               class="border-b border-[#F0EFF3] py-[6px] rowBrand">
            <div class="tw-flex items-center gap-[1%] rowBrandBg" :class="{'brandIsCurrent': brand.is_current}">
              <div class="colBrandPosName">
                <div class="positionBrand">
                  <span>{{ index + 1 }}</span>
                  <div class="circle" :style="{backgroundColor: colorsBrand[index]}"></div>
                </div>
                <div class="logoNameBrand">
                  <div class="caja-logo">
                    <img :src="brand.logo" class="logo" />

                  </div>

                  {{ brand.name }}
                </div>
              </div>
              <div class="w-[17%] text-13 text-right">
                {{ brand.times_mentioned_pct | formatNumber(2,2) }} %
              </div>
            </div>

          </div>

          <div class="border-b border-[#F0EFF3] py-[6px] rowBrand">
            <div class="tw-flex items-center gap-[1%] rowBrandBg">
              <div class="colBrandPosName">
                <div class="positionBrand">
                  <span>{{ '-' }}</span>
                  <div class="circle" style="background-color: #ccc"></div>
                </div>
                <div class="logoNameBrand">
                  <div class="caja-logo">

                  </div>
                  {{ others.name }}
                </div>

              </div>
              <div class="w-[17%] text-13 text-right">
                {{ others.times_mentioned_pct | formatNumber(2,2) }} %
              </div>
            </div>

          </div>
        </div>
        </div>


    <div class="box mt-[16px]">
      <span class="title"><translate>Analysis of indirect prompts</translate></span>
      <p class="subTitle">{{ $gettext("Shows brand visibility in responses to indirect prompts (which do not name the brand) in LLMs.") }}</p>
      <div class="grid grid-cols-[minmax(0,4fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)] border-b border-[#000] pb-[12px]">
        <div class="font-semibold">
          <translate>Top Indirect Prompts</translate>
        </div>
        <div v-for="(llm, index) in llms" :key="index" class="text-center">
          <img :src="getLogoByLLM(llm)" class="h-[16px]" alt=""  />
        </div>
      </div>
      <div v-for="(item, index) in topIndirectPrompts" :key="'q'+index"
           class="grid items-center text-13 grid-cols-[minmax(0,4fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)] border-b border-[#F0EFF3] py-[12px]">
        <div class="cursor-pointer linkPrompt"  @click="showQuestion = true; dataQuestion = item.text">
          {{ item.text }}
        </div>
        <div v-for="(llm, index) in llms" :key="index" class="text-center">
          <img :src="verifyIndirectPromptsVisibility(item.text, llm)" class="h-[21px]" alt=""  />
        </div>
      </div>
    </div>
      <ModalQuestion :data="data" :question="dataQuestion" :show="showQuestion" @update:show="showQuestion = $event"></ModalQuestion>

    </div>
  </div>
</template>
<script>
import LatestAnalysis from "@/components/IAReputation/LatestAnalysis.vue"
import ChartVisibility from "@/components/IAReputation/ChartVisibility.vue"
import ProgressBarVisibilityLLM from "@/components/IAReputation/ProgressBarVisibilityLLM.vue"
import MixinIAReputation from "@/mixins/iareputation.js"
import SkeletonCard from '@/components/common/skeletonCard.vue'
import ChartCompetitors from '@/components/IAReputation/ChartCompetitors.vue'
//import ChartBarsLLM from "@/components/IAReputation/ChartBarsLLM.vue"
import ModalQuestion from "@/components/IAReputation/ModalQuestion.vue"

import SrvIAReputationService from "@/services/iareputation.js"
export default {
  components: {ChartVisibility, LatestAnalysis, ProgressBarVisibilityLLM, SkeletonCard, ChartCompetitors, ModalQuestion},
  mixins: [MixinIAReputation],
  props: ['geoData'],
  data() {
    return {
      data: null,
      loading: false,
      colorsBrand: ['#87A2FB','#5E38D7', '#E26C6C', '#FFB574', '#F3B5EF', '#5FBCA2', '#D77D38', '#BA87FB', '#FF7F54', '#B5F3D5'],
      showQuestion: false,
      dataQuestion: null
    }
  },
  async mounted(){
    this.loading = true
    if (!this.geoData) {
      const {status, data} = await SrvIAReputationService.getReputation({brand_uuid: this.brandUUID})
      if (status === 200) {
        this.data = data
      }
    } else {
      this.data = this.geoData
    }
    this.loading = false
  },
  computed: {
    competitors () {
      if (!this.data) return []
      return this.data.aggregated_ranking.filter(e => e.known)
    },
    others () {
      if (!this.data) return []
      let others = 0
      this.data.aggregated_ranking.filter(e => !e.known).forEach(x => {
        others += x.times_mentioned_pct
      })
      return {
        name: 'Otras', times_mentioned_pct: others
      }

    },
    dataChartCompetitors () {
      if (!this.data) return {labels: [], datasets: [{data: [], backgroundColor: []}]}
      const competitors = this.competitors
      let others = 0
      this.data.aggregated_ranking.filter(e => !e.known).forEach(x => {
        others += x.times_mentioned_pct
      })
      return {
        labels: [...competitors.map(e => e.name), 'Otras'],
        datasets: [{
          data: [...competitors.map(e => e.times_mentioned_pct), others],
          backgroundColor: [...this.colorsBrand.slice(0, competitors.length),'#D5D5D5']
        }]
      }
    },
    numberOfPrompts () {
      if (!this.data) return 0
      return this.data.reputation_index['openai'].prompts_answers.indirect.length
    },
    numberOfLLMs () {
      if (!this.data) return 0
      return Object.keys(this.data.reputation_index).length
    },
    globalPercent () {
      if (!this.data) return 0
      let count = 0
      this.llms.forEach(item => {
        if (this.data.reputation_index[item]) {
          count += this.data.reputation_index[item].metrics_results.visibility.total_visibility
        }
      })
      return (count / (this.numberOfLLMs * this.numberOfPrompts)) * 100
    },
    makeRangesContinuous () {
      const steps = 10;               // nº de marcas
      const denom = steps - 1;        // para incluir N al final
      return Array.from({ length: steps }, (_, i) =>
        Math.round((i * this.totalPromptsVisibility) / denom)
      );
    },
    topIndirectPrompts () {
      // this.data
      if (this.data) {
        return this.data.reputation_index.openai.prompts_answers.indirect
      }
      return []
    },
    metricsVisibility () {
      if (this.data) {
        let items = []
        Object.keys(this.data.reputation_index).map((key)  => {
          if (key !== 'aggregated_google_alignment_ia') {
            items.push({...this.data.reputation_index[key], llm: key})
          }
         // return {...key, avg_score: value.metrics_results.visibility.total_ratio_pct}
        })
        return [...items || []].sort((a, b) => b.metrics_results.visibility.total_ratio_pct - a.metrics_results.visibility.total_ratio_pct)
      }
      return []
    },
    totalPromptsVisibility () {
      if (this.data) {
        return this.data.reputation_index.openai.metrics_results.visibility.total_prompts
      }
      return 0
    },
    references () {
      let refs = []
      if (this.data) {
        Object.keys(this.data.reputation_index).forEach(e => {

          this.data.reputation_index[e].prompts_answers.indirect.forEach(x => {
            refs = refs.concat(...x.references)
          })
        })
        const seen = new Set();
        console.log(refs.length)
        return refs.filter(({ title, url }) => {
          const key = `${title?.trim().toLowerCase()}|${url?.trim().toLowerCase()}`;
          if (seen.has(key)) return false;
          seen.add(key);
          return true;
        }).slice(0,8);
      }

      return []
    },
    domains () {
      let domains = []
      this.references.forEach(({ url }) => {
        if (!domains.includes(this.getHostname(url))) domains.push(this.getHostname(url))
      })

      domains = domains.map(e => {
        console.log(this.data.reputation_index['openai'].prompts_answers.indirect.flatMap(it =>
          Array.isArray(it.references) ? it.references : []
        ))
        return {
          domain: e,
          count: this.references.filter(c => c.url.indexOf(e) > -1).length,
          openai: this.data.reputation_index['openai'].prompts_answers.indirect.flatMap(it =>
            Array.isArray(it.references) ? it.references : []
          ).filter(x => x.url.indexOf(e) > -1).length > 0
        }
      })
      console.log(domains)
      return domains
    }
  },
  methods: {
    getHostname (u) {
      const s = String(u).trim();
      const withProto = /^[a-zA-Z][a-zA-Z\d+\-.]*:\/\//.test(s) ? s : 'http://' + s;
      return new URL(withProto).hostname.toLowerCase();
    }
  }
}
</script>
<style lang="scss">
.circle{
  width: 10px;
  height: 10px;
  border-radius: 100%;
}
.rowBrand {
  font-size: 13px;
  .rowBrandBg {
    padding-left: 6px;
    padding-right: 6px;
  }
  .colBrandPosName{
    width: 81%;
    display: flex;
    align-items: center;
    gap: 1%;
    .positionBrand{
      display: flex;
      align-items: center;
      span{
        width: 20px;
      }
    }
    .logoNameBrand{
      display: flex;
      align-items: center;
      margin-left: 20px;
      gap: 20px;
      font-size: 13px;
      font-weight: 600;
      .caja-logo {
        width: 90px; /* Ejemplo de ancho fijo */
        height: 38px; /* Ejemplo de alto fijo */
        display: flex; /* Opcional: Centrar el logo dentro de la caja */
        justify-content: center;
        align-items: center;
        border:0  ;
      }

      /* 2. Reglas para el logo flexible */
      .logo {
        /* ¡Importante! El logo debe tener 100% del tamaño del contenedor */
        max-width: 100%;
        max-height: 100%;
        width: 100%;
        height: 100%;

        /* La propiedad clave: Escala el contenido para que quepa, manteniendo su relación de aspecto. */
        object-fit: contain;
      }
    }
  }

  .brandIsCurrent {
    background-color: #F2F2F2;
    border-radius: 4px;
    margin: 2px 0;
    padding-top: 5px;
    padding-bottom: 5px;
  }
}
</style>
